import useAnalytics from '@/hooks/useAnalytics.js';
import usePrismicSelector from '@/hooks/usePrismicSelector.js';
import useSentryConsent from '@/hooks/useSentryConsent.js';

const useAppInit = () => {
    usePrismicSelector();
    useAnalytics();
    useSentryConsent();
};

export default useAppInit;
